namespace GeniuzPOS.Lookups {
    export class LookupBgColorColumns {
        static columnsKey = 'Lookups.LookupBgColor';
    }
}
